import { render, staticRenderFns } from "./xitongduijie-ningbo.vue?vue&type=template&id=6fd135e9&scoped=true&"
import script from "./xitongduijie-ningbo.vue?vue&type=script&lang=ts&"
export * from "./xitongduijie-ningbo.vue?vue&type=script&lang=ts&"
import style0 from "./xitongduijie-ningbo.vue?vue&type=style&index=0&id=6fd135e9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd135e9",
  null
  
)

export default component.exports